import { useState, useRef } from "react"
import { useTranslation } from "react-i18next"
import { CircleFlag } from "react-circle-flags"

import { useOnClickOutside } from "../../utils/useOnClickOutside"

import {
  apiSlice,
} from "../../app/apiSlice"

export const Localizations = () => {
  const { i18n } = useTranslation("gift_card")

  const {
    data: configData,
  } = apiSlice.endpoints.getConfig.useQueryState()
  const locale = configData?.locales?.find((locale: any) => locale.code === i18n.language) || configData?.locales?.[0]

  const [ localesIsOpen, setLocalesIsOpen ] = useState<boolean>(false)
  const localesRef = useRef<HTMLDivElement>(null)
  useOnClickOutside(localesRef, () => { setLocalesIsOpen(false) })

  return (
    <div className="relative lg:flex lg:py-2.5 lg:px-2.5 lg:border-b lg:w-full lg:border-b-[#BBBFCA]">
      <button className="lg:ml-auto border lg:border-none border-[#C1C1C1] flex justify-center items-center gap-2 rounded py-1 px-1 size-8 lg:size-auto lg:h-8 bg-[#FFFFFF] text-[#0D0D0D] [&>svg]:size-6"
        type="button"
        onClick={() => { setLocalesIsOpen(!localesIsOpen) }}
      >
        <span className="hidden lg:block text-sm">{locale?.locale_name}</span> <CircleFlag width={24} height={24} countryCode={locale?.code === "en" ? "gb" : locale?.code} />
      </button>
      {localesIsOpen && (
        <div ref={localesRef} className="absolute top-full right-0 z-50 overflow-y-auto flex flex-col justify-start items-start gap-2 rounded-[1.125rem] p-4 w-72.5 max-h-96 bg-[#FFFFFF] text-[#4F5867] shadow-card-shadow">
          {configData?.locales?.map((locale: any) => {
            return (
              <button key={locale.id} className="flex justify-start items-center gap-2 p-1.5"
                type="button"
                onClick={() => {
                  i18n.changeLanguage(locale.code)
                  setLocalesIsOpen(false)
                }}
              >
                <CircleFlag width={24} height={24} countryCode={locale.code === "en" ? "gb" : locale.code} /> {locale.locale_name}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
